// src/contexts/SiteModeContext.jsx
import React, { createContext, useContext, useEffect, useState } from "react";
import {
  DEFAULT_SITE_MODE,
  SITE_MODE_DEMO,
  SITE_MODE_MAIRIE,
} from "../config/demoConfig";

const SiteModeContext = createContext(null);

const STORAGE_KEY = "monapplimairie_site_mode";

const sanitizeMode = (value) => {
  const v = String(value || "").toLowerCase().trim();
  if (v === SITE_MODE_DEMO) return SITE_MODE_DEMO;
  if (v === SITE_MODE_MAIRIE || v === "classic") return SITE_MODE_MAIRIE;
  return DEFAULT_SITE_MODE;
};

const getInitialMode = () => {
  try {
    if (typeof window !== "undefined") {
      const stored = window.localStorage.getItem(STORAGE_KEY);
      if (stored) return sanitizeMode(stored);
    }
  } catch (e) {
    console.warn("SiteMode localStorage error:", e);
  }
  return DEFAULT_SITE_MODE;
};

export function SiteModeProvider({ children }) {
  const [mode, setModeState] = useState(getInitialMode);

  const setMode = (next) => {
    const clean = sanitizeMode(next);
    setModeState(clean);
  };

  useEffect(() => {
    try {
      if (typeof window !== "undefined") {
        window.localStorage.setItem(STORAGE_KEY, mode);
      }
    } catch (e) {
      console.warn("SiteMode localStorage write error:", e);
    }
  }, [mode]);

  const value = {
    mode,
    setMode,
    isDemo: mode === SITE_MODE_DEMO,
    isMairie: mode === SITE_MODE_MAIRIE,
  };

  return (
    <SiteModeContext.Provider value={value}>
      {children}
    </SiteModeContext.Provider>
  );
}

// Hook pratique
export const useSiteMode = () => {
  const ctx = useContext(SiteModeContext);
  if (!ctx) {
    throw new Error("useSiteMode doit être utilisé dans <SiteModeProvider>.");
  }
  return ctx;
};
